import {
  GET_AMLS_TM_COMMON_TRANSACTION_HISTORY,
  GET_AMLS_TM_COMMON_TRANSACTION_HISTORY_SUCCESS,
  GET_AMLS_TM_COMMON_TRANSACTION_HISTORY_FAIL,
  GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_TYPOLOGIES,
  GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_TYPOLOGIES_SUCCESS,
  GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_TYPOLOGIES_FAIL,
  GET_SCORE_EXPLAINABLITY,
  GET_SCORE_EXPLAINABLITY_SUCCESS,
  GET_SCORE_EXPLAINABLITY_FAIL,
  DOWNLOAD_AMLS_TM_COMMON_TRANSACTION_HISTORY,
  DOWNLOAD_AMLS_TM_COMMON_TRANSACTION_HISTORY_SUCCESS,
  DOWNLOAD_AMLS_TM_COMMON_TRANSACTION_HISTORY_FAIL,
  GET_PEER_AND_PROFILE_GRAPH,
  GET_PEER_AND_PROFILE_GRAPH_SUCCESS,
  GET_PEER_AND_PROFILE_GRAPH_FAIL,
  GET_TYPOLOGY_LIST,
  GET_TYPOLOGY_LIST_SUCCESS,
  GET_TYPOLOGY_LIST_FAIL,
  GET_RISK_INDICATOR_LIST_BY_TOPOLOGY_ID,
  GET_RISK_INDICATOR_LIST_BY_TOPOLOGY_ID_SUCCESS,
  GET_RISK_INDICATOR_LIST_BY_TOPOLOGY_ID_FAIL,
  GET_PREVENTION_SCORE_EXPLAINABLITY,
  GET_PREVENTION_SCORE_EXPLAINABLITY_SUCCESS,
  GET_PREVENTION_SCORE_EXPLAINABLITY_FAIL,
  GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_VARIANTS_SUCCESS,
  GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_VARIANTS_FAIL,
  GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_VARIANTS,
  GET_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS,
  GET_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS_SUCCESS,
  GET_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS_FAIL,
  DOWNLOAD_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS,
  DOWNLOAD_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS_FAIL,
  DOWNLOAD_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS_SUCCESS,
  GET_AMLS_TM_COMMON_TRANSACTION_TYPES_FILTER,
  GET_AMLS_TM_COMMON_TRANSACTION_TYPES_FILTER_SUCCESS,
  GET_AMLS_TM_COMMON_TRANSACTION_TYPES_FILTER_FAIL
} from '../actions/tmCommon';

export const initialState = {
  transactionHistory: {
    isLoading: true,
    error: null,
    data: null
  },
  transactionHistoryDownloaded: {
    isLoading: false,
    error: null,
    data: null
  },
  transactionTriggeredTypologies: {
    isLoading: true,
    error: null,
    data: null
  },
  scoreExplainability: {
    isLoading: false,
    data: null,
    error: null
  },
  preventionScoreExplainability: {
    isLoading: false,
    data: null,
    error: null
  },
  peerProfileGraph: {
    isLoading: true,
    data: null,
    error: null
  },
  typologyList: {
    isLoading: true,
    data: null,
    error: null
  },
  riskIndicatorList: {
    isLoading: true,
    data: null,
    error: null
  },
  transactionTriggeredVariants: [],
  customerLoanDetails: {
    isLoading: false,
    data: {},
    error: null
  },
  downloadedLoanDetails: {
    data: {},
    error: null
  },
  transactionTypesFilter: {
    isLoading: false,
    error: null,
    data: null
  }
};

function tmCommonReducer(state = initialState, action) {
  switch (action.type) {
    case GET_AMLS_TM_COMMON_TRANSACTION_HISTORY:
      return {
        ...state,
        transactionHistory: {
          ...state.transactionHistory,
          ...initialState.transactionHistory
        }
      };
    case GET_AMLS_TM_COMMON_TRANSACTION_HISTORY_SUCCESS:
      return {
        ...state,
        transactionHistory: {
          isLoading: false,
          error: null,
          data: action.payload
        }
      };
    case GET_AMLS_TM_COMMON_TRANSACTION_HISTORY_FAIL:
      return {
        ...state,
        transactionHistory: {
          isLoading: false,
          data: null,
          error: {
            ...action.payload
          }
        }
      };

    case DOWNLOAD_AMLS_TM_COMMON_TRANSACTION_HISTORY:
      return {
        ...state,
        transactionHistoryDownloaded: {
          ...initialState.transactionHistoryDownloaded,
          ...state.transactionHistoryDownloaded,
          isLoading: true
        }
      };
    case DOWNLOAD_AMLS_TM_COMMON_TRANSACTION_HISTORY_SUCCESS:
      return {
        ...state,
        transactionHistoryDownloaded: {
          isLoading: false,
          error: null,
          data: null // BE handled the download, so no data needed here
        }
      };
    case DOWNLOAD_AMLS_TM_COMMON_TRANSACTION_HISTORY_FAIL:
      return {
        ...state,
        transactionHistoryDownloaded: {
          isLoading: false,
          data: null,
          error: {
            ...action.payload
          }
        }
      };

    case GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_TYPOLOGIES:
      return {
        ...state,
        transactionTriggeredTypologies: {
          ...initialState.transactionTriggeredTypologies,
          ...state.transactionTriggeredTypologies
        }
      };
    case GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_TYPOLOGIES_SUCCESS:
      return {
        ...state,
        transactionTriggeredTypologies: {
          isLoading: false,
          error: null,
          data: action.payload
        }
      };
    case GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_TYPOLOGIES_FAIL:
      return {
        ...state,
        transactionTriggeredTypologies: {
          isLoading: false,
          data: null,
          error: {
            ...action.payload
          }
        }
      };
    case GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_VARIANTS:
      return {
        ...state,
        transactionTriggeredVariants: []
      };
    case GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_VARIANTS_SUCCESS:
      return {
        ...state,
        transactionTriggeredVariants: action.payload
      };
    case GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_VARIANTS_FAIL:
      return {
        ...state,
        transactionTriggeredVariants: []
      };

    case GET_SCORE_EXPLAINABLITY:
      return {
        ...state,
        scoreExplainability: {
          ...initialState.scoreExplainability,
          ...state.scoreExplainability,
          isLoading: true
        }
      };
    case GET_SCORE_EXPLAINABLITY_SUCCESS:
      return {
        ...state,
        scoreExplainability: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case GET_SCORE_EXPLAINABLITY_FAIL:
      return {
        ...state,
        scoreExplainability: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };
    case GET_PEER_AND_PROFILE_GRAPH:
      return {
        ...state,
        peerProfileGraph: {
          ...initialState.peerProfileGraph
        }
      };
    case GET_PEER_AND_PROFILE_GRAPH_SUCCESS:
      return {
        ...state,
        peerProfileGraph: {
          isLoading: false,
          data: [...action.payload],
          error: null
        }
      };
    case GET_PEER_AND_PROFILE_GRAPH_FAIL:
      return {
        ...state,
        peerProfileGraph: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };
    case GET_TYPOLOGY_LIST:
      return {
        ...state,
        typologyList: {
          ...initialState.typologyList,
          ...state.typologyList
        }
      };
    case GET_TYPOLOGY_LIST_SUCCESS:
      return {
        ...state,
        typologyList: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case GET_TYPOLOGY_LIST_FAIL:
      return {
        ...state,
        typologyList: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };
    case GET_RISK_INDICATOR_LIST_BY_TOPOLOGY_ID:
      return {
        ...state,
        riskIndicatorList: {
          ...initialState.riskIndicatorList,
          ...state.riskIndicatorList
        }
      };
    case GET_RISK_INDICATOR_LIST_BY_TOPOLOGY_ID_SUCCESS:
      return {
        ...state,
        riskIndicatorList: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case GET_RISK_INDICATOR_LIST_BY_TOPOLOGY_ID_FAIL:
      return {
        ...state,
        riskIndicatorList: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };

    case GET_PREVENTION_SCORE_EXPLAINABLITY:
      return {
        ...state,
        preventionScoreExplainability: {
          ...initialState.preventionScoreExplainability,
          ...state.preventionScoreExplainability,
          isLoading: true
        }
      };
    case GET_PREVENTION_SCORE_EXPLAINABLITY_SUCCESS:
      return {
        ...state,
        preventionScoreExplainability: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case GET_PREVENTION_SCORE_EXPLAINABLITY_FAIL:
      return {
        ...state,
        preventionScoreExplainability: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };
    case GET_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS:
      return {
        ...state,
        customerLoanDetails: {
          ...initialState.customerLoanDetails,
          ...state.customerLoanDetails,
          isLoading: true
        }
      };
    case GET_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS_SUCCESS:
      return {
        ...state,
        customerLoanDetails: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case GET_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS_FAIL:
      return {
        ...state,
        customerLoanDetails: {
          isLoading: false,
          data: {},
          error: action.payload
        }
      };
    case DOWNLOAD_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS:
      return {
        ...state,
        downloadedLoanDetails: {
          ...initialState.downloadedLoanDetails,
          ...state.downloadedLoanDetails
        }
      };
    case DOWNLOAD_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS_SUCCESS:
      return {
        ...state,
        downloadedLoanDetails: {
          data: action.payload,
          error: null
        }
      };
    case DOWNLOAD_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS_FAIL:
      return {
        ...state,
        downloadedLoanDetails: {
          data: {},
          error: action.payload
        }
      };

    case GET_AMLS_TM_COMMON_TRANSACTION_TYPES_FILTER:
      return {
        ...state,
        transactionTypesFilter: {
          ...initialState.transactionTypesFilter,
          isLoading: true
        }
      };
    case GET_AMLS_TM_COMMON_TRANSACTION_TYPES_FILTER_SUCCESS:
      return {
        ...state,
        transactionTypesFilter: {
          isLoading: false,
          error: null,
          data: action.payload
        }
      };
    case GET_AMLS_TM_COMMON_TRANSACTION_TYPES_FILTER_FAIL:
      return {
        ...state,
        transactionTypesFilter: {
          isLoading: false,
          data: null,
          error: {
            ...action.payload
          }
        }
      };

    default:
      return state;
  }
}

export default tmCommonReducer;
